<template>
  <div class="options shadow">
    <div class="options-header ">
      <h5 class="text-dark border-bottom m-0 pb-2">{{ title }}</h5>
    </div>
    <div class="options-content">
      <slot />
    </div>
  </div>
</template>

<script>
  export default {
    name: 'ItemOptions',
    props: {
      title: String
    }
  }
</script>

<style lang="scss" scoped>
  $breakpoint-xl: 1350px;
  $breakpoint-lg: 1200px;
  $breakpoint-md: 992px;
  $breakpoint-sm: 768px;

  .options {
    align-self: center;
    background-color: white;
    display: flex;
    flex-direction: column;
    height: 90%;
    max-height: 90%;
    padding: .5rem;
    position: absolute;
    width: auto;
    z-index: 2;

    .options-header {
      background-color: white;
      height: auto;
      margin-bottom: .5rem;
      padding: .5rem;
      width: 100%;
    }

    $size-xl: 280px;
    $size-lg: $size-xl - 20px;
    $size-md: $size-lg - 20px;
    $size-sm: $size-md - 20px;

    .options-content {
      flex: 1;
      height: auto;
      margin-bottom: .5rem;
      padding: .5rem;
      position: relative;
      overflow-x: hidden;
      overflow-y: auto;
      width: $size-xl;

      @media (max-width: $breakpoint-xl) {
        width: $size-xl;
      }

      @media (max-width: $breakpoint-lg) {
        width: $size-lg;
      }

      @media (max-width: $breakpoint-md) {
        width: $size-md;
      }

      @media (max-width: $breakpoint-sm) {
        width: $size-sm;
      }

      @mixin scroll-shadow {
        -webkit-box-shadow: inset 0 0 .1rem #AAA;
        -moz-box-shadow: inset 0 0 .1rem #AAA;
        box-shadow: inset 0 0 .1rem #AAA;
      }

      &::-webkit-scrollbar-track {
        @include scroll-shadow;
        background-color: #F5F5F5;
        border-radius: .5rem;
      }

      &::-webkit-scrollbar {
        width: .5rem;
        background-color: #F5F5F5;
        border-radius: .5rem;
      }

      &::-webkit-scrollbar-thumb {
        @include scroll-shadow;
        background-color: #aaa;
        border-radius: .5rem;
      }
    }

    $border-radius: .25rem;

    &.options-left {
      border-bottom-right-radius: $border-radius;
      border-top-right-radius: $border-radius;
    }

    &.options-right {
      border-bottom-left-radius: $border-radius;
      border-top-left-radius: $border-radius;
    }

    @mixin options-side($side) {
      $transition: #{$side} .25s ease-in-out;

      &.options-#{$side} {
        .options-header {
          #{$side}: -20px;
        }

        #{$side}: 0;
        -webkit-transition: $transition;
        -moz-transition: $transition;
        transition: $transition;

        &:hover,
        &:focus-within {
          #{$side}: 0;
        }

        @media (max-width: $breakpoint-xl) {
          #{$side}: -($size-xl - 10px);
        }

        @media (max-width: $breakpoint-lg) {
          #{$side}: -($size-lg - 10px);
        }

        @media (max-width: $breakpoint-md) {
          #{$side}: -($size-md - 10px);
        }

        @media (max-width: $breakpoint-sm) {
          #{$side}: -($size-sm - 10px);
        }
      }
    }

    @include options-side('left');

    @include options-side('right');
  }
</style>